import CreateRemarkPopupComponent from './create.remark.popup.component';
export default angular.module('invision.customercare.createRemarkPopup', []).component('createRemarkPopup', CreateRemarkPopupComponent).name;